
import React from "react";
import Lottie from 'react-lottie';
import animationData from './construction.json';

import style from './construction.module.css'

const Construction = () =>{
    const defaultOptions = {loop: true, autoplay: true, animationData: animationData, rendererSettings: {preserveAspectRatio: 'xMidYMid slice'}}
    return (
      <>
        <div className={style.divLoading}>
          <div>
            <span className={"cl-white"}>Economiza</span>
            <span className={"cl-white"}>Nosso site está em construção, mas em 2022 chegaremos com um novo sistema ideal para você :D</span>
          </div>
          <div>
            <Lottie options={defaultOptions} height={350} width={350} />
          </div>
        </div>
      </>
    );
}

export default Construction;